// Libs
import { createContext } from "react";

// Types
type TAuthContextProviderProps = {
    children: React.ReactNode
}

// Create initial empty context
const AuthContext = createContext<any | null>(null);

/**
 * Main app context
 * @param {*} props
 * @returns
 */
const AuthContextProvider = ({ children }: TAuthContextProviderProps) => {
    /**
     * Returns a boolean value indicating whether the current user is in the specified role.
     * The function is only intended to work with values from the enumeration `ENUM_ROLES` from AuthContext.
     * @param {String} role The name of the role to search for.
     * @returns {Boolean} true if the current user is in the specified role; otherwise, false.
     * @access public
     */
    const isInRole = (role: string) => {

        return true;
    };

    return (
        <AuthContext.Provider value={{
            isInRole: isInRole,
        }}>
            {children}
        </AuthContext.Provider>
    );
};


export default AuthContextProvider;
export { AuthContext };
